import type { FaireBrandEntity } from "../../entity_types/brand";

export const homemadeIsh: FaireBrandEntity = {
  token: "homemade-ish",
  type: "brand",
  name: "Homemade-ish",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  description: "Premium baking kits with a surprise inside",
  rating: 4.8,
  location: "Manhattan, NY",
  minimumOrderDollars: 125,
  tags: ["baking", "gift", "premium"],
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
